/*
 * @Autor: 李建鹏
 * @Date: 2022-06-23 13:54:38
 * @LastEditTime: 2022-06-23 16:13:46
 */
const MODEL_NAME = 'protocol'
export default [
  {
    path: `/${MODEL_NAME}/service-guarantee`,
    name: 'service-guarantee',
    component: () =>
      import(
        /* webpackChunkName: "protocol-service-guarantee" */ '@pages/protocol/serviceGuarantee.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/qualification`,
    name: 'qualification',
    component: () =>
      import(
        /* webpackChunkName: "protocol-qualification" */ '@pages/protocol/qualification/index.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/qualification-list`,
    name: 'qualificationList',
    component: () =>
      import(
        /* webpackChunkName: "protocol-qualification-list" */ '@pages/protocol/qualification/list.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/qualification-content`,
    name: 'qualificationContent',
    component: () =>
      import(
        /* webpackChunkName: "protocol-qualification-content" */ '@pages/protocol/qualification/content.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/sdk-list`,
    name: 'qualificationSdkList',
    component: () =>
      import(
        /* webpackChunkName: "protocol-qualification-content" */ '@pages/protocol/qualification/sdkList.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/basic-business`,
    name: 'basicBusiness',
    component: () =>
      import(
        /* webpackChunkName: "protocol-qualification-content" */ '@pages/protocol/document/basicBusiness.vue'
      )
  }
]
